<template>
  <b-modal id="EstablishmentRoleInfo" scrollable size="lg" centered hide-footer>
    <template #modal-title>
      <h3>
        <img src="@/assets/images/establishment-roles.svg" class="icon-lg" />
        {{ $t("setting.others.establishmentRolesMsgs.data") }}
      </h3>
    </template>
    <div class="row">
      <DataLabelGroup
        :className="'col-lg-12'"
        :value="establishmentRoleData.establishmentRoleNameAr"
        :title="$t('setting.others.establishmentRolesMsgs.nameAr')"
        :imgName="'establishment-roles.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-12'"
        :value="establishmentRoleData.establishmentRoleNameEn"
        :title="$t('setting.others.establishmentRolesMsgs.nameEn')"
        :imgName="'establishment-roles.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-12'"
        :value="establishmentRoleData.establishmentRoleNameUnd"
        :title="$t('setting.others.establishmentRolesMsgs.nameUnd')"
        :imgName="'establishment-roles.svg'"
      />

      <DataLabelGroup
        :className="'col-lg-6'"
        :value="establishmentRoleData.establishmentRoleDescriptionAr"
        :title="$t('setting.others.establishmentRolesMsgs.descriptionAr')"
        :imgName="'description.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="establishmentRoleData.establishmentRoleDescriptionEn"
        :title="$t('setting.others.establishmentRolesMsgs.descriptionEn')"
        :imgName="'description.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="establishmentRoleData.establishmentRoleDescriptionUnd"
        :title="$t('setting.others.establishmentRolesMsgs.descriptionUnd')"
        :imgName="'description.svg'"
      />

      <DataLabelGroup
        :className="'col-lg-6'"
        :value="establishmentRoleData.establishmentRoleNotes"
        :title="$t('notes')"
        :imgName="'notes.svg'"
      />
    </div>
  </b-modal>
</template>

<script>
import DataLabelGroup from "@/components/general/DataLabelGroup.vue";
import { setDataMultiLang, timeToLang } from "@/utils/functions";

export default {
  name: "EstablishmentRoleInfo",
  components: {
    DataLabelGroup,
  },
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["establishmentRoleData"],
  methods: {
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      return setDataMultiLang(lang, dataAr, dataEn);
    },
  },
  async created() {},
};
</script>

<style scoped lang="scss"></style>
